// extracted by mini-css-extract-plugin
export default {"innerWrapper":"nA-z","tooltipWrapper":"oA-z","icon":"pA-z","tooltip":"qA-z","content":"rA-z"};